import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ListPickerData } from 'shared/components/chat-messages/list-picker/list-picker.model';

@Component({
  selector: 'list-picker-message',
  templateUrl: './list-picker-message.component.html',
  styleUrls: ['./list-picker-message.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ListPickerMessageComponent {
  public listPicker: ListPickerData;
  public anyItemsHaveImages: boolean = false;

  @Input() direction: string;
  @Input() set listPickerJson(json: string) {
    this.listPicker = JSON.parse(json);
    this.anyItemsHaveImages = this.listPicker.listPicker.sections[0].items.some(i => i.image && i.image.url != null);
  }
}
